"use strict";
/* eslint-disable import/extensions */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
// eslint-disable-next-line import/extensions
var StyledComponets_1 = require("./StyledComponets");
var OverflowTooltipText_1 = __importDefault(require("./OverflowTooltipText"));
var VoiceAgentLayoutUtils_1 = require("./VoiceAgentLayoutUtils");
var VoiceAgentSidebar = function (_a) {
    var isLoading = _a.isLoading, agentOptions = _a.agentOptions, _b = _a.workflowAgentOptions, workflowAgentOptions = _b === void 0 ? [] : _b, selectedSelection = _a.selectedSelection, _c = _a.selectedWorkflowAgentId, selectedWorkflowAgentId = _c === void 0 ? null : _c, onCommonSelect = _a.onCommonSelect, onAgentSelect = _a.onAgentSelect, onWorkflowAgentSelect = _a.onWorkflowAgentSelect, onAddAgent = _a.onAddAgent;
    // Ordinary and workflow agents are one list to the user, in the order they
    // were created. The backend assigns ids in that order, so sorting on them
    // restores it; an agent still being created has no numeric id yet and so
    // sorts last, where it was just added.
    var orderKey = function (id) {
        var numeric = Number(id);
        return Number.isFinite(numeric) ? numeric : Number.MAX_SAFE_INTEGER;
    };
    var sidebarAgents = __spreadArrays(agentOptions.map(function (agent) { return (__assign(__assign({}, agent), { isWorkflow: false })); }), workflowAgentOptions.map(function (agent) { return (__assign(__assign({}, agent), { isWorkflow: true })); })).sort(function (first, second) { return orderKey(first.id) - orderKey(second.id); });
    return (react_1["default"].createElement(StyledComponets_1.StyledAgentsSidebar, null,
        react_1["default"].createElement(StyledComponets_1.StyledAgentSidebarCard, { isActive: selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION, onClick: onCommonSelect, style: { width: '100%', height: '40px', margin: '16px 0 0 0' } },
            react_1["default"].createElement(OverflowTooltipText_1["default"], { text: "Common Configuration" })),
        react_1["default"].createElement("div", { style: { borderBottom: '1px solid #efefef', margin: '8px 0' } }),
        react_1["default"].createElement(text_1["default"], { variant: "h3.bold", color: "black.haptik" }, "AGENTS"),
        isLoading ? (react_1["default"].createElement(box_1["default"], { height: "100%", alignItems: "center", justifyContent: "center" },
            react_1["default"].createElement(loader_1["default"], { themed: true }))) : (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '8px' } }, sidebarAgents.map(function (agent) { return (react_1["default"].createElement(StyledComponets_1.StyledAgentSidebarCard, { key: agent.isWorkflow ? "workflow-" + agent.id : agent.id, isActive: agent.isWorkflow
                    ? agent.id === selectedWorkflowAgentId
                    : agent.id === selectedSelection, onClick: function () {
                    return agent.isWorkflow
                        ? onWorkflowAgentSelect === null || onWorkflowAgentSelect === void 0 ? void 0 : onWorkflowAgentSelect(agent.id) : onAgentSelect(agent.id);
                }, style: { minWidth: 0, width: '100%' } },
                react_1["default"].createElement(OverflowTooltipText_1["default"], { text: agent.name }))); })),
            react_1["default"].createElement(StyledComponets_1.StyledAddAgentButton, { themed: true, variant: "secondary", onClick: onAddAgent, style: { width: '100%', height: '40px', margin: '16px 0 0 0' } }, "Add Agent")))));
};
exports["default"] = VoiceAgentSidebar;
